import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: ${(props) => props.width};
  height: ${(props) => (props.height ? props.height : '60vh')};
  background: ${(props) => props.theme.colors.card};
  overflow: hidden;
  border-radius: 10px;
  padding: 15px;
  box-sizing: border-box;
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'unset')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const IconEmpty = styled.img`
  width: ${(props) => (props.width ? props.width : '')};
  height: ${(props) => (props.height ? props.height : '')};
  margin: 15px;
`;

export const SpanEmpty = styled.span`
  color: ${(props) => props.theme.colors.label};
  margin: 1.5vh;
  font-size: 3.0vh;
  font-style: italic;
`;